<template>
	<AsiDialogFormLayout :icon="icons.state" :title="$t('user.state')"
	                     :open="open" :loading="loading" :valid="valid && savableStateSelected" :errors="errors"
	                     @save="requestSave" @cancel="cancel" unwrapped scrollable>
		<v-card-text class="pa-6">
			<v-form v-model="valid">
				<v-row>
					<v-col>
						<AsiSelect v-model="state" :label="$t('user.state')" :placeholder="$t('user.state')"
						           :items="options" :rules="rules"/>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
	</AsiDialogFormLayout>
</template>

<script lang="ts">
	import {Component, Emit, Prop, Watch} from "vue-property-decorator";
	import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
	import AsiDialogFormLayout from "@/components/common/AsiDialogFormLayout.vue";
	import {ValidationRule} from "@/declarations/ValidationRule";
	import {UserState} from "@/helpers/constants";
	import EnumHelper from "@/helpers/EnumHelper";
	import AsiSelect from "@/components/common/AsiSelect";
	import {IUserAdminBlamable} from "@/models/user/UserAdminModels";
	import UserRules from "@/models/user/UserRules";

	@Component({
		components: {AsiSelect, AsiDialogFormLayout}
	})
	export default class UserUpdateDialogState extends AsiDialogForm {

		@Prop({type: Object, required: true})
		public user!: IUserAdminBlamable;

		private state: UserState | null = null;

		private get savableStateSelected(): boolean {
			return this.state !== UserState.created;
		}

		// noinspection JSMethodCanBeStatic
		private get options(): { text: string, value: string | number }[] {
			return EnumHelper
				.toSelectItems(UserState, true)
				.filter(s => this.user.state === UserState.created ? true : s.value !== UserState.created);
		}

		// noinspection JSMethodCanBeStatic
		private get rules(): ValidationRule[] {
			return UserRules.stateRules;
		}

		@Watch('user.state', {immediate: true})
		private onUserStateChanged(value: UserState): void {
			this.state = value;
		}

		@Emit('save')
		public save(): void {
			return;
		}

		@Emit('cancel')
		public cancel(event: Event): Event {
			this.state = this.user.state;
			const form = this.$refs.form as HTMLFormElement;
			this.reset([], form);
			return event;
		}

		private requestSave(): void {
			if (this.state === null) return;

			this.loading = true;
			this.$userServiceAdmin.updateState(this.user.id, this.state)
				.then(this.save)
				.catch(this.handleErrors)
				.finally(() => this.loading = false);
		}

	}
</script>

<style lang="scss" scoped>

</style>
